var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacility = (_ref, ref) => {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.32 55.05",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.71,54.74c.25-2.53.57-5.06.72-7.59A5.72,5.72,0,0,1,15.17,43a61.93,61.93,0,0,0,4.66-5.76c.1,1.3.23,2.67.32,4,.29,4.48.56,9,.84,13.44Z",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.79,31.75c4.52-4.59,4.78-6.91,1.2-12.27,2.3.41,4.39.75,6.46,1.17a48.59,48.59,0,0,1,11.8,3.63,14.34,14.34,0,0,1,2.48,1.52c1.8,1.4,1.73,3.06-.37,3.93A27.31,27.31,0,0,1,36,31.46,66.88,66.88,0,0,1,20.79,31.75Z",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43,25.37c.91,5.47,4.37,8,9.94,7-.45.59-.77,1-1.13,1.49A64.3,64.3,0,0,1,6.88,45.33a15.45,15.45,0,0,1-3.15,1.82c-2.36,1-3.69,0-3.38-2.53a21.81,21.81,0,0,1,1.19-4.69A69.17,69.17,0,0,1,9.23,25.47S9.36,25.41,9.43,25.37Z",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.84,18.74c-5.88-2.6-10.25.88-11.37,5.06-1-2.85-2-5.68-2.92-8.55A39.61,39.61,0,0,1,4.46,4.31a9.31,9.31,0,0,1,.23-2C5.1.36,6.22-.19,7.89.78a11.64,11.64,0,0,1,2.56,2C14.83,7.41,17.84,12.91,20.84,18.74Z",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17,21.11A4.05,4.05,0,0,1,21.1,25.2a4.13,4.13,0,1,1-8.25,0A4.05,4.05,0,0,1,17,21.11Z",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacility);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facility.b7b349ec09535f88c221c8cd2ed9ba26.svg";